import { useCallback, useEffect, useState } from 'react';
import { client } from '../sdkAdapter';

export interface SeoOption {
    id: number;
    url: string;
    meta_title?: string;
}

const extractSeoCollection = (response: any): SeoOption[] => {
    if (Array.isArray(response)) {
        return response;
    }

    const candidates = [
        response?.data?.data?.data,
        response?.data?.data,
        response?.data,
        response,
    ];

    const items = candidates.find((value) => Array.isArray(value));
    return Array.isArray(items) ? items : [];
};

export function useSeoOptions() {
    const [seoOptions, setSeoOptions] = useState<SeoOption[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchSeoOptions = useCallback(async () => {
        setLoading(true);
        try {
            const response = await (client as any).getApiAttributesSeos() as any;
            const items = extractSeoCollection(response)
                .filter((item): item is SeoOption => typeof item?.id === 'number')
                .sort((left, right) => left.id - right.id);

            setSeoOptions(items);
        } catch (error) {
            console.error('Failed to fetch SEO options:', error);
            setSeoOptions([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        void fetchSeoOptions();
    }, [fetchSeoOptions]);

    return {
        seoOptions,
        seoOptionsLoading: loading,
        fetchSeoOptions,
    };
}
